import routes from '@/router/routes'
import { useAuthStore } from "@/store/auth";
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})

router.beforeEach(async (to) => {
    const authStore = useAuthStore()
    await authStore.getCurrentUser()
    console.log('to')
    console.log(to)
    if (!to.name){
        return {"name": "ErrorPage"}
    }
  })

export default router